import React from 'react'
import './ToolTip.sass'
import { Info } from '@material-ui/icons'

const ToolTip = ({ toolTip, position, content, icon, style, iconStyle }) => (
  <div className='toolTip' style={style}>
    <div className='toolTipContent'>
      {content}
      <Info data-rh={toolTip} data-rh-at={position} style={iconStyle} />
    </div>
  </div>
)

export default ToolTip
